import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { FeeNoteId, TimeMaterialFeeNotesResponse, TMFeeId } from '@business/entities/tm';
import { TmFeeNotesAPI } from '@business/api/tm_fee_notes';

// Notes on a work order's fee (Summary tab notes icon), the same as TMGroupNotesBloc for categories
export class TMFeeNotesBloc extends BaseBloc {
  private readonly repo = new Repository<TimeMaterialFeeNotesResponse>({
    getItemId: item => item.id,
  });

  readonly items$ = this.repo.items$;
  readonly notes$ = this.repo.items$;
  readonly selectItem = this.repo.selectItem;

  onReset() {
    this.repo.reset();
  }

  fetchFeeNotes = (feeId: TMFeeId) => {
    return TmFeeNotesAPI.fetchFeeNotes(feeId).pipe(
      this.repo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_tm_order_estimate_fee_notes_error') }),
    );
  };

  createFeeNote = (feeId: TMFeeId, note: string) => {
    return TmFeeNotesAPI.createFeeNote(feeId, note).pipe(
      this.repo.ops.addOne(item => item),
      handleMessage({ type: requestMessage('create_tm_order_estimate_fee_note') }),
    );
  };

  updateFeeNote = (noteId: FeeNoteId, note: string) => {
    return TmFeeNotesAPI.updateFeeNote(noteId, note).pipe(
      this.repo.ops.upsertOne(item => ({ item })),
      handleMessage({ type: requestMessage('update_tm_order_estimate_fee_note') }),
    );
  };

  deleteFeeNote = (noteId: FeeNoteId) => {
    return showDeleteConfirmation('Delete Note', 'Do you really want to remove this note?').pipe(
      switchMap(() => TmFeeNotesAPI.deleteFeeNote(noteId)),
      this.repo.ops.removeOne(() => noteId),
      handleMessage({ type: requestMessage('delete_tm_order_estimate_fee_note') }),
    );
  };
}
